(function() { window.GUID_777d6bf9_4821_48fa_99ba_a10567a267b2 = { getGuid: function() { return "777d6bf9-4821-48fa-99ba-a10567a267b2"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-csrate",
                        callback: (accordion, e) => {
                            var _a;
                            // const statFieldPalette =
                            //   accordion.$Container
                            //     .find(
                            //       `#CSRateSectionViewModelStatFieldPalette-${accordion.ContentId}`
                            //     )
                            //     ?.val() ?? "";
                            if (accordion.IsExpanded) {
                                accordion.$Content.offon("click.accordionCSRateTabMenuClicked", `#tabmenu-csrate-${accordion.ContentId}`, (e) => {
                                    const $closestTabMenuItem = $(e.target).closest(".tab-menu-item");
                                    if ($closestTabMenuItem.length) {
                                        const { popupUrl } = $closestTabMenuItem.data("html");
                                        if (popupUrl) {
                                            accordion.RefreshContent(() => { }, popupUrl);
                                        }
                                    }
                                });
                                const $statUserGraphsInputs = accordion.$Container.find(`.CSRateSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                                if ($statUserGraphsInputs.length) {
                                    try {
                                        const data = [];
                                        $statUserGraphsInputs.each((index, input) => {
                                            const $input = $(input);
                                            const val = $input.val();
                                            const parsedVal = JSON.parse(val);
                                            const isArray = Array.isArray(parsedVal);
                                            if (isArray) {
                                                data.push(...parsedVal);
                                            }
                                        });
                                        if (data.length) {
                                            const rootId = `${accordion.ContentId}-chart-root`;
                                            const chartContainerHTML = `
                    <div id="${rootId}" class="">
                    </div>
                    `;
                                            const $newChartContainer = accordion.$Container.find(".new-chart-container");
                                            if ($newChartContainer.length) {
                                                let useDivergentPalette = false;
                                                $newChartContainer.append(chartContainerHTML);
                                                const $hasMultipleSymbolsInput = accordion.$Container.find(`.CSRateSectionViewModelHasMultiplePersonas-${accordion.ContentId}`);
                                                const hasMultipleSymbols = $hasMultipleSymbolsInput.length && ((_a = $hasMultipleSymbolsInput.val().toString()) !== null && _a !== void 0 ? _a : "").toLowerCase() == "true";
                                                if (hasMultipleSymbols) {
                                                    useDivergentPalette = true;
                                                }
                                                const lineChart = new CS.Controls.LineChart(rootId, data, undefined, undefined, undefined, undefined, undefined, useDivergentPalette);
                                                lineChart.init().then(() => {
                                                    const $legacyLegendContainer = accordion.$Container.find(".csrate-section__header.custom-chart-persona-legend");
                                                    const $newLegendContainer = accordion.$Container.find(".linechartv2__line-chart__legend");
                                                    if ($legacyLegendContainer.length &&
                                                        $newLegendContainer.length) {
                                                        const $newLegendItems = $newLegendContainer.find(".linechartv2__line-chart__legend-item");
                                                        if ($newLegendItems.length) {
                                                            $newLegendItems.each((index, item) => {
                                                                const $newLegendItem = $(item);
                                                                const symbol = $newLegendItem.attr("data-symbol");
                                                                const $matchingLegacyLegendItem = $legacyLegendContainer.find(`.persona-container[data-id="${symbol}"]`);
                                                                if ($matchingLegacyLegendItem.length) {
                                                                    const $CSRateAccuracy = $matchingLegacyLegendItem.find(".cs-rate-accuracy");
                                                                    if ($CSRateAccuracy.length) {
                                                                        $newLegendItem.append($CSRateAccuracy);
                                                                    }
                                                                    $newLegendItem.append($matchingLegacyLegendItem);
                                                                    $matchingLegacyLegendItem.remove();
                                                                }
                                                            });
                                                        }
                                                        $legacyLegendContainer.remove();
                                                    }
                                                });
                                            }
                                            else {
                                                console.error("No chart container found");
                                            }
                                        }
                                    }
                                    catch (error) {
                                        console.error("Error while parsing stat user graphs", error);
                                    }
                                }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
